<template>
  <!--基本信息的位置不足填充区 -->
  <div class="basics-wrapper">
    <div
      v-if="answerSheet.acCardExamNumber > 13 && answerSheet.acCardPanes == 3"
      style="line-height: 20px; padding-top: 50px"
    >
      该
      <br />区 <br />域 <br />请 <br />勿 <br />填 <br />涂
    </div>
    <div v-else>该区域请勿填涂</div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
//基础信息区
export default {
  name: "basicsWrapper",
  props: {
    sty: String,
    layout: String,
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    // ...mapState("cardMake", ["answerSheet"]), //答卷设置参数
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.basics-wrapper {
  border: 1px solid #000 !important;
  height: 282px;
  line-height: 262px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}
</style>
